import { Wordmark } from '@novaquantis/design-system';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-[1] mt-auto w-full flex-shrink-0 border-t border-[color:var(--nq-line-soft)] bg-transparent py-4 text-foreground">
      <div className="mx-auto max-w-[var(--content-max)] px-6 text-center">
        <p className="m-0 inline-flex items-center gap-1 text-sm text-muted-foreground">
          <Wordmark size={14} /> — {currentYear}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
